import { cnpController } from '../core';

export const getCnpListOptions = async (
  ...params: Parameters<typeof cnpController.getCnpList>
) => {
  const cnpList = await cnpController.getCnpList(...params);
  return cnpList.map((item) => ({
    label: item.displayName,
    value: item.uid,
  }));
};
